import React from "react";
import './Error.css';

const Error = () => {
  return (
    <div className="error ms-0">
      <img
        src="https://webdeasy.de/wp-content/uploads/2020/06/404-pages.jpg"
        alt=""
      ></img>
    </div>
  );
};

export default Error;
